import { endOfDay, startOfDay, subDays } from "date-fns";

/** Max daily history for goals projection (from report endDateTime). */
export const GLOBAL_REPORT_GOALS_MAX_HISTORY_DAYS = 30;

export const GLOBAL_REPORT_GOALS_PROJECTION_FORECAST_DAYS = 7;

/**
 * Window for goals charts: selected range capped at last N days before endDateTime.
 * @returns {{ windowStartTime: number, windowEndTime: number, referenceDate: Date } | null}
 */
export const getGlobalReportGoalsProjectionWindow = ({
  startDateTime,
  endDateTime,
  maxHistoryDays = GLOBAL_REPORT_GOALS_MAX_HISTORY_DAYS,
}) => {
  if (!startDateTime || !endDateTime) {
    return null;
  }

  const windowEnd = endOfDay(new Date(endDateTime));
  const rangeStart = startOfDay(new Date(startDateTime));
  const maxHistoryStart = startOfDay(subDays(windowEnd, maxHistoryDays - 1));
  const windowStart =
    rangeStart.getTime() > maxHistoryStart.getTime()
      ? rangeStart
      : maxHistoryStart;

  return {
    windowStartTime: windowStart.getTime(),
    windowEndTime: windowEnd.getTime(),
    referenceDate: windowEnd,
  };
};

export default getGlobalReportGoalsProjectionWindow;
